import { selectActivePackage } from './selectActivePackage';
import { EServiceId } from '../../../../types/reducers/publishTerms';
import { createSelector } from 'reselect';
import { IAppState } from '../../../../../AppModulesWrapper';

/**
 *
 * Возвращает НЕ id пакета, а id услуги, к которому принадлежит пакет (топ, премиум и т.д.)
 */
export const selectActivePackageServiceId = createSelector(
  (state: IAppState) => selectActivePackage(state),
  (activePackage): EServiceId | null => {
    if (!activePackage) {
      return null;
    }

    return activePackage.serviceId;
  },
);
